import { put } from 'redux-saga/effects';

import { IExport } from 'APIPackage/ImportExportModule/interfaces/IExport';
import { getPlanErknmStatusTitleByStatus } from 'APIPackage/PlanListModule/common/getPlanErknmStatusTitleByStatus';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { addNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from 'CorePackage/NotificationModule/enums/MessageTypesEnum';

import {
  KNMS_HAVE_NOT_REASONS,
  FILL_KNM_PASSPORTS,
  PLAN_STATUS_UPDATE_ERROR,
  KNMS_HAVE_IN_PROCESS,
  KNMS_HAVE_IN_PROCESS_MESSAGE,
  KNMS_NOT_IN_STATUS,
  KNMS_NOT_IN_STATUS_MESSAGE,
  PLAN_CONSIDERED_ERROR,
  PLAN_CONSIDERED_ERROR_MESSAGE,
  PLAN_IN_PROCESS_ERROR,
  PLAN_IN_PROCESS_ERROR_MESSAGE,
  PLAN_STATUS_TRANSITION_IN_PROGRESS,
  HANDLING_PLAN,
  PLAN_STATUS_TRANSITION_IN_PROGRESS_ALREADY,
  PLAN_STATUS_CANT_CHANGE_FORM,
  PLAN_CONSIDERED_LATE_ERROR,
  PLAN_CONSIDERED_LATE_ERROR_MESSAGE,
  PLAN_CHANGE_TO_UNDER_CONSIDERATION,
  PLAN_CHANGE_TO_UNDER_CONSIDERATION_MESSAGE,
  ERKNM_PLAN_UNDER_CONSIDERATION_LATE_ERROR,
  PLAN_CHANGE_STATUS_ERROR_COMMON,
  PLAN_IS_EMPTY,
  PLAN_STATUS_CHANGE_IN_PROCESS,
  PLAN_STATUS_CHANGE_IN_PROCESS_MESSAGE,
} from '../constants/notices';

export function* notifyExportSuccess(id: IExport['id']) {
  yield put(
    addNoticeAction({
      noticeType: NoticeTypesEnum.SUCCESS,
      messageType: MessageTypesEnum.EXPORT,
      renderContent: '',
      exportId: id,
    }),
  );
}

export function* notifyExportError() {
  yield put(
    addNoticeAction({
      noticeType: NoticeTypesEnum.ERROR,
      messageType: MessageTypesEnum.FILE_UPLOAD,
      renderContent: 'Произошла ошибка при выгрузке файла',
    }),
  );
}

export function* notifyPlanStatusesUpdateError(errMessage: string, status?: ErknmPlanStatusesEnum) {
  let renderContent;

  if (errMessage.includes(KNMS_HAVE_NOT_REASONS)) {
    renderContent = FILL_KNM_PASSPORTS;
  } else if (errMessage.includes(KNMS_HAVE_IN_PROCESS)) {
    renderContent = KNMS_HAVE_IN_PROCESS_MESSAGE;
  } else if (errMessage.includes(KNMS_NOT_IN_STATUS)) {
    renderContent = KNMS_NOT_IN_STATUS_MESSAGE;
  } else if (errMessage.includes(PLAN_CONSIDERED_ERROR)) {
    renderContent = PLAN_CONSIDERED_ERROR_MESSAGE;
  } else if (errMessage.includes(PLAN_CONSIDERED_LATE_ERROR)) {
    renderContent = PLAN_CONSIDERED_LATE_ERROR_MESSAGE;
  } else if (errMessage.includes(PLAN_IN_PROCESS_ERROR)) {
    renderContent = PLAN_IN_PROCESS_ERROR_MESSAGE;
  } else if (errMessage.includes(PLAN_CHANGE_TO_UNDER_CONSIDERATION)) {
    renderContent = PLAN_CHANGE_TO_UNDER_CONSIDERATION_MESSAGE;
  } else if (PLAN_STATUS_TRANSITION_IN_PROGRESS.test(errMessage)) {
    renderContent = HANDLING_PLAN;
  } else if (PLAN_STATUS_TRANSITION_IN_PROGRESS_ALREADY.test(errMessage)) {
    renderContent = `Осуществляется процесс перевода плана в статус "${getPlanErknmStatusTitleByStatus(status)}".`;
  } else if (errMessage.includes(PLAN_STATUS_CANT_CHANGE_FORM)) {
    renderContent = `План уже переведен в статус "${getPlanErknmStatusTitleByStatus(
      status,
    )}". Пожалуйста, обновите страницу.`;
  } else if (errMessage.includes('после 2022-11-02')) {
    renderContent = ERKNM_PLAN_UNDER_CONSIDERATION_LATE_ERROR;
  } else if (errMessage.includes(PLAN_CHANGE_STATUS_ERROR_COMMON) || errMessage.includes(PLAN_IS_EMPTY)) {
    renderContent = errMessage;
  } else if (errMessage.includes(PLAN_STATUS_CHANGE_IN_PROCESS)) {
    renderContent = PLAN_STATUS_CHANGE_IN_PROCESS_MESSAGE;
  } else {
    renderContent =
      (status &&
        `Перевод плана в статус "${getPlanErknmStatusTitleByStatus(
          status || null,
        )}" невозможен, так как план не подписан и/или в нём присутствуют не подписанные КНМ`) ||
      PLAN_STATUS_UPDATE_ERROR;
  }

  yield put(
    addNoticeAction({
      noticeType: NoticeTypesEnum.ERROR,
      messageType: MessageTypesEnum.UPDATE_PLAN_STATUSES,
      renderContent,
    }),
  );
}

export function* notifyPlanStatusesUpdateSuccess() {
  yield put(
    addNoticeAction({
      noticeType: NoticeTypesEnum.SUCCESS,
      messageType: MessageTypesEnum.UPDATE_PLAN_STATUSES,
      renderContent: 'Запрос успешно обработан. План будет переведен в следующий статус.',
    }),
  );
}
